const PRODUCT_SLUGS = ['denuncianr1', 'onecomply'] as const;

export const PRODUCT_NOT_ACCESSIBLE_MESSAGE =
  'DenunciaNR1 não está disponível para esta empresa. Contrate ou regularize o pagamento no Admin OneAuth.';

interface JwtProductClaim {
  slug?: string;
  accessible?: boolean;
}

export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const parts = token.split('.');

  if (parts.length !== 3) {
    return null;
  }

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded);

    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function isProductAccessibleInJwt(token: string): boolean {
  const payload = decodeJwtPayload(token);

  if (payload === null) {
    return false;
  }

  const products = payload['products'];

  if (!Array.isArray(products) || products.length === 0) {
    return true;
  }

  for (const item of products) {
    if (typeof item !== 'object' || item === null) {
      continue;
    }

    const product = item as JwtProductClaim;
    const slug = product.slug ?? '';

    if (!PRODUCT_SLUGS.includes(slug as (typeof PRODUCT_SLUGS)[number])) {
      continue;
    }

    return product.accessible === true;
  }

  return false;
}
